import {
  ReceiptText,
  Truck,
  TruckElectric,
  ArrowDownToLine,
  BringToFront,
  ArrowUpToLine,
  CirclePile,
  ArrowUpDown,
} from '@carboledger/ui/icons';
import { ROUTES } from '@/app/routes';

const ICON = 16;

// A leaf gets a `link` only once its screen exists; without one it renders inert.
export const buildWorkspaceNav = (module, t) => {
  return [
    {
      id: 'inbounds',
      label: t('NAV_INBOUNDS'),
      isExpandable: true,
      children: [
        {
          id: 'contracts',
          label: t('NAV_CONTRACTS'),
          link: ROUTES.contracts(module),
          icon: <ReceiptText size={ICON} />,
        },
        {
          id: 'incoming-shipments',
          label: t('NAV_INCOMING_SHIPMENTS'),
          link: ROUTES.incomingShipments(module),
          icon: <Truck size={ICON} />,
        },
        {
          id: 'declarations',
          label: t('NAV_INCOMING_DECLARATIONS'),
          link: ROUTES.declarations(module),
          icon: <ArrowDownToLine size={ICON} />,
        },
      ],
    },
    {
      id: 'outbounds',
      label: t('NAV_OUTBOUNDS'),
      isExpandable: true,
      children: [
        {
          id: 'orders',
          label: t('NAV_ORDERS'),
          link: ROUTES.orders(module),
          icon: <BringToFront size={ICON} />,
        },
        {
          id: 'outgoing-shipments',
          label: t('NAV_OUTGOING_SHIPMENTS'),
          link: ROUTES.outgoingShipments(module),
          icon: <TruckElectric size={ICON} />,
        },
        {
          id: 'allocations',
          label: t('NAV_ALLOCATIONS'),
          link: ROUTES.allocations(module),
          icon: <ArrowUpToLine size={ICON} />,
        },
      ],
    },
    {
      id: 'monitor',
      label: t('NAV_MONITOR'),
      isExpandable: true,
      children: [
        {
          id: 'inventory',
          label: t('NAV_INVENTORY'),
          link: ROUTES.inventory(module),
          icon: <CirclePile size={ICON} />,
        },
        {
          id: 'transactions',
          label: t('NAV_TRANSACTIONS'),
          link: ROUTES.transactions(module),
          icon: <ArrowUpDown size={ICON} />,
        },
      ],
    },
  ];
};

export const findActiveNavId = (pathname, nav) => {
  let match = null;
  const walk = (nodes) => {
    for (const node of nodes) {
      if (node.link && (pathname === node.link || pathname.startsWith(`${node.link}/`))) {
        if (!match || node.link.length > match.link.length) match = node;
      }
      if (node.children) walk(node.children);
    }
  };
  walk(nav);
  return match?.id;
};
